/**
 * <s-upsell-variant> — keeps a compact upsell card's hidden variant input,
 * price, image and add button in sync with its finish <select>.
 */
class SUpsellVariant extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const select = this.querySelector('select[data-upsell-select]');
    if (!select) return;

    select.addEventListener('change', () => this.#sync(select), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync(select) {
    const option = select.selectedOptions[0];
    if (!option) return;

    const card = this.closest('[data-upsell-card]') || this;
    const input = this.querySelector('input[name="id"]');
    if (input) input.value = option.value;

    const price = card.querySelector('[data-upsell-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    const image = card.querySelector('img[data-quick-image]');
    if (image && option.dataset.imageSrc) {
      image.removeAttribute('srcset');
      image.src = option.dataset.imageSrc;
    }

    const button = this.querySelector('button[name="add"]');
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
    }
  }
}

if (!customElements.get('s-upsell-variant')) {
  customElements.define('s-upsell-variant', SUpsellVariant);
}
